var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid fondo-main"},[_c('Nav'),_c('Header',{staticClass:"hide-on-med-and-down fondo-grass"}),_c('h1',{staticClass:"fondo-oscuro center z-depth-3"},[_vm._v("Stadiums")]),_c('br'),_c('br'),_c('Stadiums')],1)}
var staticRenderFns = []

export { render, staticRenderFns }